import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import _ from 'lodash'
import { ObservableMap } from 'mobx'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useContractCues } from 'modules/contracts/lib/contractCuesContext'

interface Props {
  title: string
  employeeName: string
}

const prepareLinks = (
  employeeName: string,
  title: string,
  fieldMap: ObservableMap<unknown, unknown[]>
) => {
  const allTheLinks = _.uniq(
    [...fieldMap]
      .map(([key, value]) => {
        return value.map((element) => ({ anchor: key, incidenceName: element }))
      })
      .flat()
  )

  return (
    <Box
      paddingX="s64"
      paddingY="s24"
      alignItems="center"
      width="full"
      background="champagne400"
      flexDirection="row"
      justifyContent="flexStart"
      border={{
        bottom: {
          style: 'solid',
          width: 's1',
          color: 'champagne800',
        },
        top: {
          style: 'solid',
          width: 's1',
          color: 'champagne800',
        },
      }}
    >
      <Box paddingRight="s24">
        <Icon.Large icon="alert" color="champagne1000" />
      </Box>
      <Box>
        <Text.Normal size="300" weight="semibold">
          {title}
        </Text.Normal>
        <Text.Normal size="200" weight="normal">
          {allTheLinks.map((link, index) => {
            const linksLength = allTheLinks.length
            let joinWith = ' '
            let last = false
            if (linksLength > 1 && index < linksLength - 2) {
              joinWith = ','
            }
            if (linksLength > 1 && index === linksLength - 2) {
              joinWith = i18n.t('contract_versions.cues_alert.and')
              last = true
            }
            return (
              <Box key={index} inline flexDirection="row">
                <a href={`#${link.anchor}`}>
                  <Text.Normal size="200" weight="normal" underlined>
                    {String(link.incidenceName)}
                  </Text.Normal>
                </a>
                {last && <Box paddingRight="s4" inline></Box>}
                <Text.Normal size="200" weight="normal">
                  {joinWith}
                </Text.Normal>
                <Box paddingRight="s4" inline></Box>
              </Box>
            )
          })}

          {i18n.tp('contract_versions.cues_banner.description', {
            count: allTheLinks.length,
            employeeName: employeeName,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}

const ContractCuesBanner = ({ employeeName, title }: Props) => {
  const contractCues = useContractCues()

  if (contractCues.hasCues && contractCues.listOfFields && contractCues.listOfFields.size > 0) {
    const listOfFields = contractCues.listOfFields
    const alertWithMessage = prepareLinks(employeeName, title, listOfFields)

    return alertWithMessage
  } else return null
}

export default observer(ContractCuesBanner)
